import { SatPopoverModule } from '@ncstate/sat-popover';
import { Injectable, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { MatListModule } from '@angular/material/list';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatChipsModule } from '@angular/material/chips';
import { MatSortModule } from '@angular/material/sort';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDividerModule } from '@angular/material/divider';
import { FirmennameComponent } from '../features/clients/clients/usersearch/firmenname/firmenname.component';
import { JeinDialogComponent } from './jein-dialog/jein-dialog.component';
import { ChooseClientComponent } from './choose-client/choose-client.component';
import { AccountInfoComponent } from '../features/clients/clients/usersearch/account-info/account-info.component';
import { TicketShortComponent } from '../features/tickets/ticket-short/ticket-short.component';
import { RouterModule } from '@angular/router';
import { ProtokollComponent } from '../features/clients/client/protokoll/protokoll.component';
import { CallListComponent } from './call-list/call-list.component';
import { ClientCallListComponent } from './client-call-list/client-call-list.component';
import { ChooseUserComponent } from './choose-user/choose-user.component';
import { DateAdapter, MAT_DATE_FORMATS, NativeDateAdapter } from '@angular/material/core';
import { ClientNotizenComponent } from './client-notizen/client-notizen.component';
import { NotizComponent } from './notiz/notiz.component';
import { SafehtmlPipe } from './safehtml.pipe';
import { EditNotizComponent } from './edit-notiz/edit-notiz.component';
import { AdminNameActionIndicatorComponent } from './call-list/admin-name-action-indicator/admin-name-action-indicator.component';
import { TerminEditorComponent } from './termin-editor/termin-editor.component';
import { TableViewerComponent } from './table-viewer/table-viewer.component';
import { MarkdownPipe } from './markdown.pipe';
import { AttachmentUploaderComponent } from './attachment-uploader/attachment-uploader.component';
import { CommentComponent } from './comment/comment.component';
import { EditCommentComponent } from './edit-comment/edit-comment.component';
import { OptionsdialogComponent } from './optionsdialog/optionsdialog.component';
import { TicketsComponent } from '../features/tickets/tickets/tickets.component';
import { EditAccountToDoComponent } from './edit-account-to-do/edit-account-to-do.component';
import { DatePickerComponent } from './date-picker/date-picker.component';
import { ScrollingModule } from '@angular/cdk/scrolling';

@Injectable()
export class MyDateAdapter extends NativeDateAdapter {
    getFirstDayOfWeek(): number {
        return 1;
    }
    parse(value: any): Date | null {
        if (typeof value === 'string' && value.split('.').length > 1 && value.indexOf('.') > -1) {
            const str = value.split('.');
            if (str.length < 2 || isNaN(+str[0]) || isNaN(+str[1]) || isNaN(+str[2])) {
                return null;
            }
            let year = Number(str[2]);
            if (year < 100) {
                if (year > 50) {
                    year = Number('19' + str[2]);
                } else {
                    year = Number('20' + str[2]);
                }
            }
            return new Date(year, Number(str[1]) - 1, Number(str[0]), 12);
        } else if (typeof value === 'string' && value.split('.').length === 1) {
            if (value.length === 8) {
                const jahr = parseFloat(value.substr(4, 4));
                const monat = parseFloat(value.substr(2, 2)) - 1;
                const tag = parseFloat(value.substr(0, 2));
                return new Date(jahr, monat, tag, 12);
            }
            if (value.length === 6) {
                const jahr = 2000 + parseFloat(value.substr(4, 2));
                const monat = parseFloat(value.substr(2, 2)) - 1;
                const tag = parseFloat(value.substr(0, 2));
                return new Date(jahr, monat, tag, 12);
            }
        }
        const timestamp = typeof value === 'number' ? value : Date.parse(value);
        return isNaN(timestamp) ? null : new Date(timestamp);
    }
}

const MY_DATE_FORMATS = {
    parse: {
        dateInput: { month: 'short', year: 'numeric', day: 'numeric' },
    },
    display: {
        // dateInput: { month: 'short', year: 'numeric', day: 'numeric' },
        dateInput: 'input',
        monthYearLabel: { year: 'numeric', month: 'short' },
        dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
        monthYearA11yLabel: { year: 'numeric', month: 'long' },
    },
};

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        MatButtonModule,
        MatDialogModule,
        MatSelectModule,
        MatTabsModule,
        MatInputModule,
        MatProgressSpinnerModule,
        MatChipsModule,
        MatCardModule,
        MatSidenavModule,
        MatCheckboxModule,
        MatSlideToggleModule,
        MatDividerModule,
        MatListModule,
        MatTooltipModule,
        MatSnackBarModule,
        MatToolbarModule,
        MatRadioModule,
        MatIconModule,
        MatMenuModule,
        MatFormFieldModule,
        MatTableModule,
        MatDatepickerModule,
        MatSortModule,
        SatPopoverModule,
        MatProgressBarModule,
        ScrollingModule,
    ],
    declarations: [
        FirmennameComponent,
        JeinDialogComponent,
        ChooseClientComponent,
        AccountInfoComponent,
        TicketShortComponent,
        ProtokollComponent,
        CallListComponent,
        ClientCallListComponent,
        ChooseUserComponent,
        ClientNotizenComponent,
        NotizComponent,
        SafehtmlPipe,
        EditNotizComponent,
        AdminNameActionIndicatorComponent,
        TerminEditorComponent,
        TableViewerComponent,
        MarkdownPipe,
        AttachmentUploaderComponent,
        CommentComponent,
        EditCommentComponent,
        TicketsComponent,
        OptionsdialogComponent,
        EditAccountToDoComponent,
        DatePickerComponent,
    ],
    exports: [
        FormsModule,
        MatButtonModule,
        MatToolbarModule,
        FirmennameComponent,
        ProtokollComponent,
        TicketShortComponent,
        MatRadioModule,
        ClientCallListComponent,
        AccountInfoComponent,
        MatSelectModule,
        MatTabsModule,
        ClientNotizenComponent,
        MatDatepickerModule,
        MatInputModule,
        EditAccountToDoComponent,
        MatProgressSpinnerModule,
        MatChipsModule,
        MatCardModule,
        MatSidenavModule,
        MatCheckboxModule,
        MatListModule,
        MatMenuModule,
        MatIconModule,
        MatTooltipModule,
        MatSnackBarModule,
        MatToolbarModule,
        MatIconModule,
        MatMenuModule,
        MatFormFieldModule,
        MatTableModule,
        MatSortModule,
        MatDialogModule,
        CallListComponent,
        SafehtmlPipe,
        MarkdownPipe,
        TicketsComponent,
        CommentComponent,
        AttachmentUploaderComponent,
        MatProgressBarModule,
        DatePickerComponent,
        ScrollingModule,
    ],
    providers: [
        { provide: DateAdapter, useClass: MyDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    ],
})
export class SharedModule {}
